import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58413b51&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=58413b51&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58413b51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58413b51')) {
      api.createRecord('58413b51', component.options)
    } else {
      api.reload('58413b51', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58413b51&scoped=true", function () {
      api.rerender('58413b51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OuerTransfer/index.vue"
export default component.exports